module.exports = __webpack_public_path__ + "img/00040.679a796b.webp";